import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import { formatDate } from '@angular/common';
import { DatePipe } from '@angular/common';
import { reduce } from 'rxjs';

@Component({
  selector: 'app-dash-board',
  templateUrl: './dash-board.component.html',
  styleUrls: ['./dash-board.component.css']
})
export class DashBoardComponent implements OnInit {


  charts = [
    { id: 42, title: 'Sales Overview' },
    { id: 53, title: 'Marketing Spend' }
  ];

  dashboard1: any = false
  dashboard2: any = false
  dashboard3: any = false
  dashboard4: any = false
  dashboard5: any = false
  dashboard6: any = false
  dashboard7: any = false
  dashboard8: any = false
  dashboard9: any = false
  dashboard10: any = false
  dashboard11: any = false
  dashboard12: any = false
  dashboard13: any = false
  dashboard14: any = false
  dashboard15: any = false


  activeDashboard: number = 1;



  userCred: any = [];
  objectGroupList: any = []
  objectTypeList: any = []
  totalGroupCost: any = 0
  totalTypeCost: any = 0
  totalCurrentCost: any = 0

  ticketCounts: any = {
    closedCount: 0,
    completedCount: 0,
    openCount: 0,
    pendingCount: 0,
    reOpenCount: 0
  }

  isMaterialPurchaseAllCounts: any = true
  isMaterialIssuesAllCounts: any = false
  isMaterialTransfersAllCounts: any = false




  options: any
  barOptions: any
  dashboard: any = ""

  // Asset Charts
  assetsByTypePieData: any;
  assetsAcrossYearsBarData: any;
  assetsByTemplateBarData: any;

  assetsOriginalCostByBranchPieData: any;
  assetsCurrentCostByBranchPieData: any;
  assetsCostByTypeBarData: any;

  // Ticket Charts
  ticketsByStatusBarData: any;
  ticketsByExpectedStartMonthBarData: any;
  ticketsByExpectedClosingMonthBarData: any;

  // Inventory Dashboard Charts
  inventoryKpi: any = {};
  inventoryCategoryDistribution: any = [];
  inventoryMakeDistribution: any = [];
  inventoryStockPointStats: any = {};

  inventoryCategoryChartData: any;
  inventoryMakeChartData: any;
  inventoryBranchFilter: string = '';
  inventoryDepartmentFilter: string = '';

  // Operations Dashboard Charts
  operationsConditionMetrics: any = {};
  operationsRepairPipeline: any = {};
  operationsMonitoringStats: any = {};
  operationsWarrantyAlerts: any = {};

  operationsVendorChartData: any;
  operationsOnlineChartData: any;
  operationsBranchFilter: string = '';
  operationsDepartmentFilter: string = '';

  // Allocations Dashboard
  allocationsBranchFilter: string = '';
  allocationsDepartmentFilter: string = '';
  allocationStatus: any = {};
  departmentUtilization: any = [];
  branchUtilization: any = [];
  utilizationRateSummary: any = {};
  allocationsDepartmentChartData: any;
  allocationsBranchChartData: any;

  // Logistics & Transit Dashboard
  logisticsBranchFilter: string = '';
  logisticsDepartmentFilter: string = '';
  transitStatusBreakdown: any = {};
  transitValuation: any = {};
  highTrafficCorridors: any = [];
  logisticsHighTrafficChartData: any;


  materialPurchaseCounts: any = {
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    verifiedCount: 0
  }

  materialIssuesDayDataCounts: any = {
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    verifiedCount: 0,
    requestedCount: 0,
    issuedCount: 0,
    deployedCount: 0
  }

  materialTransfersAllCounts: any = {
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    verifiedCount: 0
  }

  materialIssuesAllCounts: any = {
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    verifiedCount: 0,
    requestedCount: 0,
    issuedCount: 0,
    deployedCount: 0
  }


  materialTransfersDayDataCounts: any = {
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    verifiedCount: 0
  }

  serviceCounts: any = {
    closedCount: 0,
    completedCount: 0,
    openCount: 0,
    pendingCount: 0,
    reOpenCount: 0
  }

  materialPurchaseDayDataCounts: any = {
    receivedCount: 0,
    approvedCount: 0,
    rejectedCount: 0,
    verifiedCount: 0
  }

  last_7_days: any
  cid: any
  usersWithoutCustomers: any = []
  serviceTypeData: any = []
  isLoading: any = false
  isRepairLoading: any = false
  isMaintenanceSchedulesLoading: any = false
  taskData: any = []
  toDayDate: any = ""

  basicData: any;
  materialPurchaseData: any;
  materialIssuesData: any;
  materialTransfersData: any;
  basicOptions: any;

  orderData: any = {}
  totalAssets: any = 0

  barData: any;

  data1: any;
  options1: any;
  data2: any;
  data3: any;
  options2: any;
  options3: any;

  groupData: any;

  materialIssuesDayData: any = [];
  materialIssuesDayDataPie: any

  materialPurchaseDayData: any = [];
  materialPurchaseDayDataPie: any

  materialTransfersDayData: any = [];
  materialTransfersDayDataPie: any

  formattedDate: any;
  ticketDayWiseCountByDateData: any
  materialPurchaseDayWiseCountDateData: any
  materialIssuesDayWiseCountDateData: any
  materialTransfersDayWiseCountDateData: any
  items: any = [
    {
      label: 'Options',
      items: [
        {
          label: 'Refresh',
          icon: 'pi pi-refresh'
        },
        {
          label: 'Export',
          icon: 'pi pi-upload'
        }
      ]
    }
  ];

  PackagingBarData = {
    labels: ["New", "In Progress", "Completed"],
    datasets: [
      {
        data: [88, 38, 55],
        backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
        hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
      }
    ]
  };

  objectConditionCountBarData: any

  deliveryBarData = {
    labels: ["New", "In Progress", "Completed"],
    datasets: [
      {

        data: [30, 38, 55],
        backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
        hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
      }
    ]
  };

  serviceTypeDate: any = ""
  materialIssuesDate: any = ""
  materialTransfersDate: any = ""
  materialPurchaseDate: any = ""
  objectInfoList: any = [];
  objectInfoRepairList: any = [];
  maintenanceSchedulesList: any = [];
  optionsNew: any;
  allowedDashboards: any = [];

  constructor(private eRef: ElementRef, private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);

    const token = sessionStorage.getItem('token')!;
    const payload = JSON.parse(
      atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))
    );
    console.log(payload);
    const ids: any = this.userCred.dashboardIds;
    // const ids: any = [1,2,3,4,5,6]

    // Direct allowed dashboard list
    this.allowedDashboards = ids || [];

    // Sort to keep dashboards in order
    this.allowedDashboards.sort((a: any, b: any) => a - b);

    // Set first dashboard as active
    this.activeDashboard = this.allowedDashboards[0];

    // Reset all dashboards
    this.dashboard1 = this.dashboard2 = this.dashboard3 =
      this.dashboard4 = this.dashboard5 = this.dashboard6 =
      this.dashboard7 = this.dashboard8 = this.dashboard9 = this.dashboard10 = this.dashboard11 = this.dashboard12 = this.dashboard13 = this.dashboard14 = this.dashboard15 = false;

    // Enable dashboards based on IDs
    ids.forEach((id: number) => {
      switch (id) {
        case 1:
          this.dashboard1 = true;
          break;
        case 2:
          this.dashboard2 = true;
          break;
        case 3:
          this.dashboard3 = true;
          break;
        case 4:
          this.dashboard4 = true;
          break;
        case 5:
          this.dashboard5 = true;
          break;
        case 6:
          this.dashboard6 = true;
          break;
        case 7:
          this.dashboard7 = true;
          break;
        case 8:
          this.dashboard8 = true;
          break;
        case 9:
          this.dashboard9 = true;
          break;
        case 10:
          this.dashboard10 = true;
          break;
        case 11:
          this.dashboard11 = true;
          break;
        case 12:
          this.dashboard12 = true;
          break;
        case 13:
          this.dashboard13 = true;
          break;
        case 14:
          this.dashboard14 = true;
          break;
        case 15:
          this.dashboard15 = true;
          break;
      }
    });

    console.log({
      dashboard1: this.dashboard1,
      dashboard2: this.dashboard2,
      dashboard3: this.dashboard3,
      dashboard4: this.dashboard4,
      dashboard5: this.dashboard5,
      dashboard6: this.dashboard6,
      dashboard7: this.dashboard7,
      dashboard8: this.dashboard8,
      dashboard9: this.dashboard9,
      dashboard10: this.dashboard10,
      dashboard11: this.dashboard11,
      dashboard12: this.dashboard12,
      dashboard13: this.dashboard13,
      dashboard14: this.dashboard14,
      dashboard15: this.dashboard15
    });

    this.toDayDate = new Date()
    this.getAllObjectInfo()
    this.formattedDate = formatDate(this.toDayDate, 'dd-MM-yyyy', 'en-US');
    this.serviceTypeDate = formatDate(this.toDayDate, 'yyyy-MM-dd', 'en-US');
    this.materialIssuesDate = formatDate(this.toDayDate, 'yyyy-MM-dd', 'en-US');
    this.materialTransfersDate = formatDate(this.toDayDate, 'yyyy-MM-dd', 'en-US');
    this.materialPurchaseDate = formatDate(this.toDayDate, 'yyyy-MM-dd', 'en-US');
    this.getTicketDayWiseCountByDate(this.formattedDate)
    this.getProspectsDayWiseCountByDate(this.formattedDate)
    this.getAllMaintenanceSchedulesByNextDueDate(formatDate(this.toDayDate, 'yyyy-MM-dd', 'en-US'))
    this.getObjectInfoByRepairExpectedEndDate(formatDate(this.toDayDate, 'yyyy-MM-dd', 'en-US'))
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectSummary()
    this.generateLastSevenDays()
    this.getObjectConditionCount()
    // this.dashboardQueryTemp()
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');



    this.basicOptions = {

    }
    this.options = {
      plugins: {
        legend: {
          display: true,
          position: 'top',
          onClick: () => { },
          labels: {
            usePointStyle: true,
          }
        }
      }
    }

    this.optionsNew = {
      plugins: {
        legend: {
          labels: {
            usePointStyle: true,
            color: textColor
          }
        }
      }
    };

    this.barOptions = {
      plugins: {
        legend: {
          display: true,
          position: 'bottom',  // ✅ place legend below chart
          onClick: () => { }, // disables click toggling
          labels: {
            usePointStyle: true, // no circle/point
            boxWidth: 0        // ⛔ removes the colored box
          }
        }
      }
    }

    this.loadAllDashboardCharts()






    this.data3 = {
      labels: this.lastSevenDays,
      datasets: [
        {
          label: 'Prospects Requested',
          backgroundColor: documentStyle.getPropertyValue('--blue-500'),
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: [65, 59, 80, 81, 56, 55, 40]
        },
        {
          label: 'Prospects Approved',
          backgroundColor: documentStyle.getPropertyValue('--pink-500'),
          borderColor: documentStyle.getPropertyValue('--pink-500'),
          data: [28, 48, 40, 19, 86, 27, 90]
        }
      ]
    };

    this.data2 = {
      labels: this.lastSevenDays,
      datasets: [
        {
          label: 'Prospects Requested',
          backgroundColor: documentStyle.getPropertyValue('--blue-500'),
          borderColor: documentStyle.getPropertyValue('--blue-500'),
          data: [65, 59, 80, 81, 56, 55, 40]
        },
        {
          label: 'Prospects Approved',
          backgroundColor: documentStyle.getPropertyValue('--pink-500'),
          borderColor: documentStyle.getPropertyValue('--pink-500'),
          data: [28, 48, 40, 19, 86, 27, 90]
        }
      ]
    };

    this.options3 = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500
            }
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };

    this.options2 = {
      indexAxis: 'y',
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor
          }
        }
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500
            }
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        },
        y: {
          ticks: {
            color: textColorSecondary
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false
          }
        }
      }
    };
    this.getAllStatusCount()
    this.getTicketStatusCount()
    this.getAllMaterialPurchaseDayWiseCount()
    this.getAllMaterialIssuesDayWiseCount()
    this.getAllMaterialTransfersDayWiseCount()
    // this.service_type_wise_ticket_day_count()
    this.getServiceTypeWiseTicketDayCountByDate(this.formattedDate)
    this.getMaterialIssuesDayWiseCountByDate(this.formattedDate)
    this.getMaterialTransfersDayWiseCountByDate(this.formattedDate)
    this.getMaterialPurchaseDayWiseCountByDate(this.formattedDate)
    this.orderData = {
      "labels": this.lastSevenDays,
      "datasets": [
        {
          "label": "Orders Received",
          "backgroundColor": [
            "rgba(255, 159, 64, 0.2)"
          ],
          "borderColor": [
            "rgb(255, 159, 64)"
          ],
          "data": [
            10,
            6,
            10,
            3,
            1,
            0,
            0
          ]
        },
        {
          "label": "Payments Received",
          "backgroundColor": [
            "rgba(75, 192, 192, 0.2)"
          ],
          "borderColor": [
            "rgb(75, 192, 192)"
          ],
          "data": [
            0,
            1,
            2,
            2,
            4,
            0,
            4
          ]
        }
      ]
    }

    this.getAllObjectInfoCounts()
  }

  dashboardChange(direction: 'next' | 'prev') {
    const index = this.allowedDashboards.indexOf(this.activeDashboard);

    if (direction === 'next') {
      if (index < this.allowedDashboards.length - 1) {
        this.activeDashboard = this.allowedDashboards[index + 1];
      } else {
        this.activeDashboard = this.allowedDashboards[0];
      }
    }

    if (direction === 'prev') {
      if (index > 0) {
        this.activeDashboard = this.allowedDashboards[index - 1];
      } else {
        this.activeDashboard = this.allowedDashboards[this.allowedDashboards.length - 1];
      }
    }

    console.log("Active dashboard:", this.activeDashboard);
  }



  getAllObjectInfoCounts() {
    this.generic_service.getAllObjectInfoCounts().subscribe(
      (res: any) => {
        console.log(res)
        this.totalAssets = res.response
      }
    )
  }


  getProspectsDayWiseCountByDate(date: any) {
    this.generic_service.getProspectsDayWiseCountByDate(date).subscribe(
      (res: any) => {
      }
    )
  }

  getAllMaterialIssuesDayWiseCount() {
    this.generic_service.getAllMaterialIssuesDayWiseCount().subscribe(
      (response: any) => {
        for (let list of response.response) {
          if (list.requestedCount != null) {
            this.materialIssuesAllCounts.requestedCount += list.requestedCount
          }
          if (list.receivedCount != null) {
            this.materialIssuesAllCounts.receivedCount += list.receivedCount
          }
          if (list.approvedCount != null) {
            this.materialIssuesAllCounts.approvedCount += list.approvedCount
          }
          if (list.rejectedCount != null) {
            this.materialIssuesAllCounts.rejectedCount += list.rejectedCount
          }
          if (list.issuedCount != null) {
            this.materialIssuesAllCounts.issuedCount += list.issuedCount
          }
          if (list.deployedCount != null) {
            this.materialIssuesAllCounts.deployedCount += list.deployedCount
          }
          if (list.verifiedCount != null) {
            this.materialIssuesAllCounts.verifiedCount += list.verifiedCount
          }
        }
      }
    )
  }

  getAllMaterialPurchaseDayWiseCount() {
    this.generic_service.getAllMaterialPurchaseDayWiseCount().subscribe(
      (response: any) => {
        for (let list of response.response) {
          if (list.receivedCount != null) {
            this.materialPurchaseCounts.receivedCount += list.receivedCount
          }
          if (list.approvedCount != null) {
            this.materialPurchaseCounts.approvedCount += list.approvedCount
          }
          if (list.rejectedCount != null) {
            this.materialPurchaseCounts.rejectedCount += list.rejectedCount
          }
          if (list.verifiedCount != null) {
            this.materialPurchaseCounts.verifiedCount += list.verifiedCount
          }
        }
      }
    )
  }

  getAllMaterialTransfersDayWiseCount() {
    this.generic_service.getAllMaterialTransfersDayWiseCount().subscribe(
      (response: any) => {
        for (let list of response.response) {
          if (list.receivedCount != null) {
            this.materialTransfersAllCounts.receivedCount += list.receivedCount
          }
          if (list.approvedCount != null) {
            this.materialTransfersAllCounts.approvedCount += list.approvedCount
          }
          if (list.rejectedCount != null) {
            this.materialTransfersAllCounts.rejectedCount += list.rejectedCount
          }
          if (list.verifiedCount != null) {
            this.materialTransfersAllCounts.verifiedCount += list.verifiedCount
          }
        }
      }
    )
  }


  getTicketStatusCount() {
    this.generic_service.getTicketStatusCount().subscribe(
      (response: any) => {
        for (let list of response.response) {
          if (list.status == "OPEN") {
            this.ticketCounts.openCount = list.count
          }
          if (list.status == "CLOSED") {
            this.ticketCounts.closedCount = list.count
          }
          if (list.status == "COMPLETED") {
            this.ticketCounts.completedCount = list.count
          }
        }
      }
    )
  }

  getAllStatusCount() {
    this.generic_service.getAllStatusCount().subscribe(
      (response: any) => {
        this.taskData = response.response
        let data: any = []
        for (let list of response.response) {
          if (list.status == "NEW" || list.status == "ASSIGNED" || list.status == "COMPLETED") {
            data.push(list)
          }
        }
        this.barData = {
          labels: data.map((item: { status: any; }) => item.status),
          datasets: [
            {
              data: data.map((item: { count: any; }) => item.count),
              backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
              hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
            }
          ]
        };


      }
    )
  }


  lastSevenDays: string[] = [];


  generateLastSevenDays() {
    const today = new Date();
    for (let i = 0; i < 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() - i);
      this.lastSevenDays.push(formatDate(date, 'dd-MM-yyyy', 'en-US'));
    }
    let dates: any = this.lastSevenDays.join(',');
    this.last_7_days = dates
    this.getTicketDayWiseCountBetweenDates(dates)
    this.getMaterialPurchaseDayWiseCountBetweenDates(dates)
    this.getMaterialIssuesDayWiseCountBetweenDates(dates)
    this.getMaterialTransfersDayWiseCountBetweenDates(dates)
    // this.getServiceTypeWiseTicketDayCountBetweenDates(dates)
    // this.getUserDayWiseTaskCountBetweenDates(dates)
  }


  serviceTypeDateArrow(arrow: any) {

    if (arrow == "+") {
      this.serviceTypeDate = new Date(this.serviceTypeDate)
      this.serviceTypeDate.setDate(this.serviceTypeDate.getDate() + 1);
      this.serviceTypeDate = formatDate(this.serviceTypeDate, 'yyyy-MM-dd', 'en-US')

    }

    if (arrow == "-") {
      this.serviceTypeDate = new Date(this.serviceTypeDate)

      this.serviceTypeDate.setDate(this.serviceTypeDate.getDate() - 1);
      this.serviceTypeDate = formatDate(this.serviceTypeDate, 'yyyy-MM-dd', 'en-US')

    }
    this.dateChange()
  }


  materialIssuesDateArrow(arrow: any) {

    if (arrow == "+") {
      this.materialIssuesDate = new Date(this.materialIssuesDate)
      this.materialIssuesDate.setDate(this.materialIssuesDate.getDate() + 1);
      this.materialIssuesDate = formatDate(this.materialIssuesDate, 'yyyy-MM-dd', 'en-US')

    }

    if (arrow == "-") {
      this.materialIssuesDate = new Date(this.materialIssuesDate)

      this.materialIssuesDate.setDate(this.materialIssuesDate.getDate() - 1);
      this.materialIssuesDate = formatDate(this.materialIssuesDate, 'yyyy-MM-dd', 'en-US')

    }
    this.materialIssuesDateChange()
  }

  materialIssuesDateChange() {
    this.isLoading = true

    let date = formatDate(this.materialIssuesDate, 'dd-MM-yyyy', 'en-US');

    this.generic_service.getMaterialIssuesDayWiseCountByDate(date).subscribe(
      (response: any) => {
        this.materialIssuesDayData = []
        this.materialIssuesDayData = response.response

        if (response.response != null) {
          this.materialIssuesDayDataCounts.receivedCount = response.response.receivedCount
          this.materialIssuesDayDataCounts.approvedCount = response.response.approvedCount
          this.materialIssuesDayDataCounts.rejectedCount = response.response.rejectedCount
          this.materialIssuesDayDataCounts.verifiedCount = response.response.verifiedCount
          this.materialIssuesDayDataCounts.requestedCount = response.response.requestedCount
          this.materialIssuesDayDataCounts.issuedCount = response.response.issuedCount
          this.materialIssuesDayDataCounts.deployedCount = response.response.deployedCount
        }



        this.isLoading = false
      }
    )
  }





  materialTransfersDateArrow(arrow: any) {

    if (arrow == "+") {
      this.materialTransfersDate = new Date(this.materialTransfersDate)
      this.materialTransfersDate.setDate(this.materialTransfersDate.getDate() + 1);
      this.materialTransfersDate = formatDate(this.materialTransfersDate, 'yyyy-MM-dd', 'en-US')

    }

    if (arrow == "-") {
      this.materialTransfersDate = new Date(this.materialTransfersDate)

      this.materialTransfersDate.setDate(this.materialTransfersDate.getDate() - 1);
      this.materialTransfersDate = formatDate(this.materialTransfersDate, 'yyyy-MM-dd', 'en-US')

    }
    this.materialTransfersDateChange()
  }

  materialTransfersDateChange() {
    this.isLoading = true

    let date = formatDate(this.materialTransfersDate, 'dd-MM-yyyy', 'en-US');

    this.generic_service.getMaterialTransfersDayWiseCountByDate(date).subscribe(
      (response: any) => {
        this.materialTransfersDayData = []
        this.materialTransfersDayData = response.response

        if (response.response != null) {
          this.materialTransfersDayDataCounts.receivedCount = response.response.receivedCount
          this.materialTransfersDayDataCounts.approvedCount = response.response.approvedCount
          this.materialTransfersDayDataCounts.rejectedCount = response.response.rejectedCount
          this.materialTransfersDayDataCounts.verifiedCount = response.response.verifiedCount
        }



        this.isLoading = false
      }
    )
  }


  materialPurchaseDateArrow(arrow: any) {

    if (arrow == "+") {
      this.materialPurchaseDate = new Date(this.materialPurchaseDate)
      this.materialPurchaseDate.setDate(this.materialPurchaseDate.getDate() + 1);
      this.materialPurchaseDate = formatDate(this.materialPurchaseDate, 'yyyy-MM-dd', 'en-US')

    }

    if (arrow == "-") {
      this.materialPurchaseDate = new Date(this.materialPurchaseDate)

      this.materialPurchaseDate.setDate(this.materialPurchaseDate.getDate() - 1);
      this.materialPurchaseDate = formatDate(this.materialPurchaseDate, 'yyyy-MM-dd', 'en-US')

    }
    this.materialPurchaseDateChange()
  }

  materialPurchaseDateChange() {
    this.isLoading = true

    let date = formatDate(this.materialPurchaseDate, 'dd-MM-yyyy', 'en-US');

    this.generic_service.getMaterialPurchaseDayWiseCountByDate(date).subscribe(
      (response: any) => {
        this.materialPurchaseDayData = []
        this.materialPurchaseDayData = response.response

        if (response.response != null) {
          this.materialPurchaseDayDataCounts.receivedCount = response.response.receivedCount
          this.materialPurchaseDayDataCounts.approvedCount = response.response.approvedCount
          this.materialPurchaseDayDataCounts.rejectedCount = response.response.rejectedCount
          this.materialPurchaseDayDataCounts.verifiedCount = response.response.verifiedCount
        }



        this.isLoading = false
      }
    )
  }



  dateChange() {
    this.isLoading = true

    let date = formatDate(this.serviceTypeDate, 'dd-MM-yyyy', 'en-US');

    this.generic_service.getServiceTypeWiseTicketDayCountByDate(date).subscribe(
      (response: any) => {
        this.serviceTypeData = []
        this.serviceTypeData = response.response
        this.isLoading = false
      }
    )
  }

  getMaterialTransfersDayWiseCountByDate(date: any) {
    this.generic_service.getMaterialTransfersDayWiseCountByDate(date).subscribe(
      (response: any) => {
        if (response.response != null) {
          if (response.response.verifiedCount == null && response.response.rejectedCount == null && response.response.receivedCount == null && response.response.approvedCount == null) {
            this.materialTransfersDayData = response.response
            this.materialTransfersDayDataPie = {
              labels: ['No Data'],
              datasets: [
                {
                  data: [100],
                  backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                  hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
                }
              ]
            };
          } else {

            this.materialTransfersDayData = response.response
            this.materialTransfersDayDataPie = {
              labels: ['received', 'approved', 'rejected', 'verified'],
              datasets: [
                {
                  data: [response.response.receivedCount, response.response.approvedCount, response.response.rejectedCount, response.response.verifiedCount],
                  backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                  hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
                }
              ]
            };
          }
        } else {
          this.materialTransfersDayData = response.response
          this.materialTransfersDayDataPie = {
            labels: ['No Data'],
            datasets: [
              {
                data: [100],
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        }



        this.options1 = {
          cutout: '80%',
          plugins: {
            legend: {
              labels: {
                color: 'black'
              }
            }
          }
        };
      }
    )
  }

  getMaterialIssuesDayWiseCountByDate(date: any) {
    this.generic_service.getMaterialIssuesDayWiseCountByDate(date).subscribe(
      (response: any) => {
        if (response.response != null) {
          this.materialIssuesDayData = response.response
          this.materialIssuesDayDataPie = {
            labels: ['requested', 'received', 'approved', 'rejected', 'issued', 'deployed', 'verified'],
            datasets: [
              {
                data: [response.response.requestedCount, response.response.receivedCount, response.response.approvedCount, response.response.rejectedCount, response.response.issuedCount, response.response.deployedCount, response.response.verifiedCount],
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        } else {
          this.materialIssuesDayData = response.response
          this.materialIssuesDayDataPie = {
            labels: ['No Data'],
            datasets: [
              {
                data: [100],
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        }



        this.options1 = {
          cutout: '80%',
          plugins: {
            legend: {
              labels: {
                color: 'black'
              }
            }
          }
        };
      }
    )
  }

  getMaterialPurchaseDayWiseCountByDate(date: any) {
    this.generic_service.getMaterialPurchaseDayWiseCountByDate(date).subscribe(
      (response: any) => {
        if (response.response != null) {
          this.materialPurchaseDayData = response.response
          this.materialPurchaseDayDataPie = {
            labels: ['requested', 'received', 'approved', 'rejected', 'issued', 'deployed', 'verified'],
            datasets: [
              {
                data: [response.response.requestedCount, response.response.receivedCount, response.response.approvedCount, response.response.rejectedCount, response.response.issuedCount, response.response.deployedCount, response.response.verifiedCount],
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        } else {
          this.materialPurchaseDayData = response.response
          this.materialPurchaseDayDataPie = {
            labels: ['No Data'],
            datasets: [
              {
                data: [100],
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        }



        this.options1 = {
          cutout: '80%',
          plugins: {
            legend: {
              labels: {
                color: 'black'
              }
            }
          }
        };
      }
    )
  }


  getServiceTypeWiseTicketDayCountByDate(date: any) {
    this.generic_service.getServiceTypeWiseTicketDayCountByDate(date).subscribe(
      (response: any) => {
        if (response.response.length != 0) {
          this.serviceTypeData = response.response
          this.data1 = {
            labels: response.response.map((item: { serviceType: any; }) => item.serviceType),
            datasets: [
              {
                data: response.response.map((item: { ticketCount: any; }) => item.ticketCount),
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        } else {
          this.serviceTypeData = response.response
          this.data1 = {
            labels: ['No Data'],
            datasets: [
              {
                data: [100],
                backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
                hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
              }
            ]
          };
        }



        this.options1 = {
          cutout: '80%',
          plugins: {
            legend: {
              labels: {
                color: 'black'
              }
            }
          }
        };
      }
    )
  }

  service_type_wise_ticket_day_count() {
    this.generic_service.service_type_wise_ticket_day_count().subscribe(
      (response: any) => {
        this.data1 = {
          labels: response.response.map((item: { serviceType: any; }) => item.serviceType),
          datasets: [
            {
              data: response.response.map((item: { ticketCount: any; }) => item.ticketCount),
              backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
              hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
            }
          ]
        };


        this.options1 = {
          cutout: '80%',
          plugins: {
            legend: {
              labels: {
                color: 'black'
              }
            }
          }
        };
      }
    )
  }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        this.usersWithoutCustomers = res.response;
      }
    )
  }



  getTicketDayWiseCountByDate(date: any) {
    this.generic_service.getTicketDayWiseCountByDate(date).subscribe(
      (res: any) => {
        // this.ticketDayWiseCountByDateData = res.response
      }
    )
  }

  transformData(date: any[]): any {
    const labels = date.map(item => item.date);
    const datasets = [
      {
        label: 'open',
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        data: date.map(item => item.openCount)
      },
      {
        label: 'closed',
        backgroundColor: ['rgba(75, 192, 192, 0.2)'],
        borderColor: ['rgb(75, 192, 192)'],
        data: date.map(item => item.closedCount)
      },
      {
        label: 'completed',
        backgroundColor: ['rgba(54, 162, 235, 0.2)'],
        borderColor: ['rgb(54, 162, 235)'],
        data: date.map(item => item.completedCount)
      }
    ];

    return { labels, datasets };
  }


  // getUserDayWiseTaskCountBetweenDates(listOfDates: any){
  //   this.generic_service.getUserDayWiseTaskCountBetweenDates(listOfDates).subscribe(
  //     (res:any)=>{
  //       console.log(res);

  //       let data: any = []
  //       const today = new Date();
  //       const date = new Date(today);


  //       for(let [index,list] of this.ticketDayWiseCountByDateData.entries()){
  //         date.setDate(today.getDate() - index);
  //         let obj: any = {
  //           closedCount: 0,
  //           completedCount: 0,
  //           date: formatDate(date, 'dd-MM-yyyy', 'en-US'),
  //           openCount: 0,
  //           reOpenCount: 0,
  //           ticketDayWiseCountId: 0
  //         }

  //         if(list != null){
  //           obj.closedCount = list.closedCount;
  //           obj.completedCount = list.completedCount;
  //           obj.date = list.date;
  //           obj.openCount = list.openCount;
  //           obj.reOpenCount = list.reOpenCount;
  //           obj.ticketDayWiseCountId = list.ticketDayWiseCountId
  //         }

  //         data.push(obj)
  //       }

  //       console.log(data)

  //       for(let list of data){

  //       }

  //     }
  //   )
  // }

  // getServiceTypeWiseTicketDayCountBetweenDates(listOfDates: any){
  //   this.generic_service.getServiceTypeWiseTicketDayCountBetweenDates(listOfDates).subscribe(
  //     (res:any)=>{
  //       console.log(res);

  //       let data: any = []
  //       const today = new Date();
  //       const date = new Date(today);


  //       for(let [index,list] of this.ticketDayWiseCountByDateData.entries()){
  //         date.setDate(today.getDate() - index);
  //         let obj: any = {
  //           closedCount: 0,
  //           completedCount: 0,
  //           date: formatDate(date, 'dd-MM-yyyy', 'en-US'),
  //           openCount: 0,
  //           reOpenCount: 0,
  //           ticketDayWiseCountId: 0
  //         }

  //         if(list != null){
  //           obj.closedCount = list.closedCount;
  //           obj.completedCount = list.completedCount;
  //           obj.date = list.date;
  //           obj.openCount = list.openCount;
  //           obj.reOpenCount = list.reOpenCount;
  //           obj.ticketDayWiseCountId = list.ticketDayWiseCountId
  //         }

  //         data.push(obj)
  //       }

  //       console.log(data)

  //       for(let list of data){

  //       }

  //     }
  //   )
  // }

  getTicketDayWiseCountBetweenDates(listOfDates: any) {
    this.generic_service.getTicketDayWiseCountBetweenDates(listOfDates).subscribe(
      (res: any) => {
        this.ticketDayWiseCountByDateData = res.response

        let data: any = []
        const today = new Date();
        const date = new Date(today);


        for (let [index, list] of this.ticketDayWiseCountByDateData.entries()) {
          date.setDate(today.getDate() - index);
          let obj: any = {
            closedCount: 0,
            completedCount: 0,
            date: formatDate(date, 'dd-MM-yyyy', 'en-US'),
            openCount: 0,
            reOpenCount: 0,
            ticketDayWiseCountId: 0
          }

          if (list != null) {
            obj.closedCount = list.closedCount;
            obj.completedCount = list.completedCount;
            obj.date = list.date;
            obj.openCount = list.openCount;
            obj.reOpenCount = list.reOpenCount;
            obj.ticketDayWiseCountId = list.ticketDayWiseCountId
          }

          data.push(obj)
        }


        this.basicData = this.transformData(data);


      }
    )
  }

  getMaterialPurchaseDayWiseCountBetweenDates(listOfDates: any) {
    this.generic_service.getMaterialPurchaseDayWiseCountBetweenDates(listOfDates).subscribe(
      (res: any) => {
        this.materialPurchaseDayWiseCountDateData = res.response

        let data: any = []
        const today = new Date();
        const date = new Date(today);


        for (let [index, list] of this.materialPurchaseDayWiseCountDateData.entries()) {
          date.setDate(today.getDate() - index);
          let obj: any = {
            approvedCount: 0,
            receivedCount: 0,
            date: formatDate(date, 'dd-MM-yyyy', 'en-US'),
            rejectedCount: 0,
            verifiedCount: 0,
            materialPurchaseDayWiseCountId: 0
          }

          if (list != null) {
            obj.approvedCount = list.approvedCount;
            obj.receivedCount = list.receivedCount;
            obj.date = list.date;
            obj.rejectedCount = list.rejectedCount;
            obj.verifiedCount = list.verifiedCount;
            obj.materialPurchaseDayWiseCountId = list.materialPurchaseDayWiseCountId
          }

          data.push(obj)
        }


        this.materialPurchaseData = this.transformMaterialPurchaseData(data);


      }
    )
  }


  transformMaterialPurchaseData(date: any[]): any {
    const labels = date.map(item => item.date);
    const datasets = [
      {
        label: 'Approved',
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        data: date.map(item => item.approvedCount)
      },
      {
        label: 'Received',
        backgroundColor: ['rgba(75, 192, 192, 0.2)'],
        borderColor: ['rgb(75, 192, 192)'],
        data: date.map(item => item.receivedCount)
      },
      {
        label: 'Rejected',
        backgroundColor: ['rgba(54, 162, 235, 0.2)'],
        borderColor: ['rgb(54, 162, 235)'],
        data: date.map(item => item.rejectedCount)
      }
    ];

    return { labels, datasets };
  }



  getMaterialIssuesDayWiseCountBetweenDates(listOfDates: any) {
    this.generic_service.getMaterialIssuesDayWiseCountBetweenDates(listOfDates).subscribe(
      (res: any) => {
        this.materialIssuesDayWiseCountDateData = res.response

        let data: any = []
        const today = new Date();
        const date = new Date(today);


        for (let [index, list] of this.materialIssuesDayWiseCountDateData.entries()) {
          date.setDate(today.getDate() - index);
          let obj: any = {
            requestedCount: 0,
            receivedCount: 0,
            approvedCount: 0,
            rejectedCount: 0,
            issuedCount: 0,
            deployedCount: 0,
            verifiedCount: 0,
            date: formatDate(date, 'dd-MM-yyyy', 'en-US'),
            materialIssuesDayWiseCountId: 0
          }

          if (list != null) {
            obj.requestedCount = list.requestedCount;
            obj.receivedCount = list.receivedCount;
            obj.approvedCount = list.approvedCount;
            obj.rejectedCount = list.rejectedCount;
            obj.issuedCount = list.issuedCount;
            obj.deployedCount = list.deployedCount;
            obj.verifiedCount = list.verifiedCount;
            obj.date = list.date;
            obj.materialIssuesDayWiseCountId = list.materialIssuesDayWiseCountId
          }

          data.push(obj)
        }
        this.materialIssuesData = this.transformMaterialIssuesData(data);
      }
    )
  }


  transformMaterialIssuesData(date: any[]): any {
    const labels = date.map(item => item.date);
    const datasets = [
      {
        label: 'Requested',
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        data: date.map(item => item.requestedCount)
      },
      {
        label: 'Received',
        backgroundColor: ['rgba(75, 192, 192, 0.2)'],
        borderColor: ['rgb(75, 192, 192)'],
        data: date.map(item => item.receivedCount)
      },
      {
        label: 'Approved',
        backgroundColor: ['rgba(54, 162, 235, 0.2)'],
        borderColor: ['rgb(54, 162, 235)'],
        data: date.map(item => item.approvedCount)
      },
      {
        label: 'Rejected',
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        data: date.map(item => item.rejectedCount)
      },
      {
        label: 'Issued',
        backgroundColor: ['rgba(75, 192, 192, 0.2)'],
        borderColor: ['rgb(75, 192, 192)'],
        data: date.map(item => item.issuedCount)
      },
      {
        label: 'Deployed',
        backgroundColor: ['rgba(54, 162, 235, 0.2)'],
        borderColor: ['rgb(54, 162, 235)'],
        data: date.map(item => item.deployedCount)
      },
      {
        label: 'Verified',
        backgroundColor: ['rgba(54, 162, 235, 0.2)'],
        borderColor: ['rgb(54, 162, 235)'],
        data: date.map(item => item.verifiedCount)
      }
    ];

    return { labels, datasets };
  }



  getMaterialTransfersDayWiseCountBetweenDates(listOfDates: any) {
    this.generic_service.getMaterialTransfersDayWiseCountBetweenDates(listOfDates).subscribe(
      (res: any) => {
        this.materialTransfersDayWiseCountDateData = res.response

        let data: any = []
        const today = new Date();
        const date = new Date(today);


        for (let [index, list] of this.materialTransfersDayWiseCountDateData.entries()) {
          date.setDate(today.getDate() - index);
          let obj: any = {
            receivedCount: 0,
            approvedCount: 0,
            rejectedCount: 0,
            verifiedCount: 0,
            date: formatDate(date, 'dd-MM-yyyy', 'en-US'),
            materialTransfersDayWiseCountId: 0
          }

          if (list != null) {
            obj.receivedCount = list.receivedCount;
            obj.approvedCount = list.approvedCount;
            obj.rejectedCount = list.rejectedCount;
            obj.verifiedCount = list.verifiedCount;
            obj.date = list.date;
            obj.materialTransfersDayWiseCountId = list.materialTransfersDayWiseCountId
          }

          data.push(obj)
        }


        this.materialTransfersData = this.transformMaterialTransfersData(data);
      }
    )
  }


  transformMaterialTransfersData(date: any[]): any {
    const labels = date.map(item => item.date);
    const datasets = [
      {
        label: 'receivedCount',
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        data: date.map(item => item.receivedCount)
      },
      {
        label: 'Approved',
        backgroundColor: ['rgba(75, 192, 192, 0.2)'],
        borderColor: ['rgb(75, 192, 192)'],
        data: date.map(item => item.approvedCount)
      },
      {
        label: 'Rejected',
        backgroundColor: ['rgba(54, 162, 235, 0.2)'],
        borderColor: ['rgb(54, 162, 235)'],
        data: date.map(item => item.rejectedCount)
      },
      {
        label: 'Verified',
        backgroundColor: ['rgba(255, 159, 64, 0.2)'],
        borderColor: ['rgb(255, 159, 64)'],
        data: date.map(item => item.verifiedCount)
      }

    ];

    return { labels, datasets };
  }






  openChart() {
  }

  openChart1() {
  }


  // dashboardChange(dashboard: any) {
  //   this.activeDashboard = dashboard;
  // }

  materialChange(material: any) {

    // let kk: any = [
    //   isMaterialPurchaseAllCounts: any = true
    //   isMaterialIssuesAllCounts: any = false
    //   isMaterialTransfersAllCounts: any = false
    // ]

    if (material == '-') {
      if (this.isMaterialPurchaseAllCounts) {
        this.isMaterialPurchaseAllCounts = false
        this.isMaterialIssuesAllCounts = false
        this.isMaterialTransfersAllCounts = true
        return
      }
      if (this.isMaterialIssuesAllCounts) {
        this.isMaterialPurchaseAllCounts = true
        this.isMaterialIssuesAllCounts = false
        this.isMaterialTransfersAllCounts = false
        return

      }
      if (this.isMaterialTransfersAllCounts) {
        this.isMaterialPurchaseAllCounts = false
        this.isMaterialIssuesAllCounts = true
        this.isMaterialTransfersAllCounts = false
        return

      }
    } else {
      if (this.isMaterialPurchaseAllCounts) {
        this.isMaterialPurchaseAllCounts = false
        this.isMaterialIssuesAllCounts = true
        this.isMaterialTransfersAllCounts = false
        return

      }
      if (this.isMaterialIssuesAllCounts) {
        this.isMaterialPurchaseAllCounts = false
        this.isMaterialIssuesAllCounts = false
        this.isMaterialTransfersAllCounts = true
        return

      }
      if (this.isMaterialTransfersAllCounts) {
        this.isMaterialPurchaseAllCounts = true
        this.isMaterialIssuesAllCounts = false
        this.isMaterialTransfersAllCounts = false
        return

      }
    }
  }


  dashboardStatus(status: any) {
    sessionStorage.setItem('dashboard-status', status)
    window.location.href = "admin/ticketlist"

  }


  getAllObjectSummary() {
    this.isLoading = true
    this.generic_service.getAllObjectSummary().subscribe(
      (res: any) => {
        console.log(res)
        for (let list of res.response) {
          if (list.objectGroup && list.objectGroup != null && list.objectGroup.length != 0) {
            for (let groupList of list.objectGroup) {
              if (groupList.currentCost && groupList.currentCost != null && groupList.currentCost != undefined && groupList.currentCost != 0) {
                this.objectGroupList.push(groupList)
                if (groupList.currentCost && groupList.currentCost != null && groupList.currentCost != undefined) {
                  this.totalGroupCost += Number(groupList.currentCost)
                }
              }

            }
          }

          if (list.objectType && list.objectType != null && list.objectType.length != 0) {
            for (let typeList of list.objectType) {
              if (typeList.currentCost && typeList.currentCost != null && typeList.currentCost != undefined && typeList.currentCost != 0) {
                this.objectTypeList.push(typeList)
                if (typeList.currentCost && typeList.currentCost != null && typeList.currentCost != undefined) {
                  this.totalTypeCost += Number(typeList.currentCost)
                }
              }

            }
          }
        }

        this.totalCurrentCost = this.totalGroupCost
        this.isLoading = false

      },
      (error: any) => {
        this.isLoading = false
      }
    )
  }

  @ViewChild('myChart') chart: ElementRef | any;

  ngAfterViewInit() {
    // const canvas = this.chart.nativeElement.querySelector('canvas');
    // canvas.style.height = '1000px';
  }

  getObjectInfoByGroup(group: any) {
    this.generic_service.getObjectInfoByGroup(group).subscribe(
      (res: any) => {
        console.log(res)

        let originalCost: any = []
        let currentCost: any = []
        let labels: any = []

        for (let list of res.response) {
          if (list.currentCost != null && list.currentCost != undefined) {
            currentCost.push(list.currentCost)
          } else {
            currentCost.push(0)
          }

          if (list.originalCost != null && list.originalCost != undefined) {
            originalCost.push(list.originalCost)
          } else {
            originalCost.push(0)
          }
          labels.push(list.name)
        }

        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        this.groupData = {
          labels: labels,
          datasets: [
            {
              label: 'Original Cost',
              backgroundColor: documentStyle.getPropertyValue('--blue-500'),
              borderColor: documentStyle.getPropertyValue('--blue-500'),
              data: originalCost
            },
            {
              label: 'Current Cost',
              backgroundColor: documentStyle.getPropertyValue('--pink-500'),
              borderColor: documentStyle.getPropertyValue('--pink-500'),
              data: currentCost
            }
          ]
        };
      },
      (error: any) => {
        console.log(error)
      }
    )
  }






  currencies: any = [
    { code: 'INR', label: '₹ INR (India)', locale: 'en-IN' },
    { code: 'USD', label: '$ USD (United States)', locale: 'en-US' },
    { code: 'EUR', label: '€ EUR (Europe)', locale: 'fr-FR' },
    { code: 'GBP', label: '£ GBP (UK)', locale: 'en-GB' },
    { code: 'JPY', label: '¥ JPY (Japan)', locale: 'ja-JP' }
  ];

  // Default currency and locale
  selectedCurrency: any = this.currencies[0]; // Default: INR

  selectedLocale: string = 'en-IN';

  dashboardQueryTemp() {
    this.generic_service.dashboardQueryTemp().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length != null && res.response.length !== 0) {

          // Extract labels & data
          const labels = res.response.map((item: any) =>
            item.acquisitionDate_6cf047 === null ? "Unknown" : item.acquisitionDate_6cf047
          );

          const values = res.response.map((item: any) => item.count_e2942a);

          // Build chart data
          this.objectConditionCountBarData = {
            labels: labels,
            datasets: [
              {
                label: "Asset Distribution across years",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }



  getObjectConditionCount() {
    this.generic_service.getObjectConditionCount().subscribe(
      (res: any) => {
        console.log(res)
        let good: any = 0
        let underRepair: any = 0
        let scrap: any = 0

        if (res.response && res.response.length != null && res.response.length != 0) {
          for (let list of res.response) {
            if (list.good && list.good != null && list.good != undefined) {
              good = + list.good
            }
            if (list.underRepair && list.underRepair != null && list.underRepair != undefined) {
              underRepair = + list.underRepair
            }
            if (list.scrap && list.scrap != null && list.scrap != undefined) {
              scrap = + list.scrap
            }
          }
        }
        this.objectConditionCountBarData = {
          labels: ["Good", "Under Repair", "Scrap"],
          datasets: [
            {
              data: [good, underRepair, scrap],
              backgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021'],
              hoverBackgroundColor: ['#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9', '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E', '#EAB8A1', '#D5B021']
            }
          ]
        };
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getObjectInfoByRepairExpectedEndDate(repairExpectedEndDate: any) {
    this.isRepairLoading = true
    this.generic_service.getObjectInfoByRepairExpectedEndDate(repairExpectedEndDate).subscribe(
      (response: any) => {
        console.log(response);
        this.objectInfoRepairList = response.response || []
        this.isRepairLoading = false
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllMaintenanceSchedulesByNextDueDate(nextDueDate: any) {
    this.isMaintenanceSchedulesLoading = true
    this.generic_service.getAllMaintenanceSchedulesByNextDueDate(nextDueDate).subscribe(
      (response: any) => {
        console.log(response);
        this.maintenanceSchedulesList = response.response || []
        this.isMaintenanceSchedulesLoading = false
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllObjectInfo() {
    this.generic_service.getAllObjectInfo().subscribe(
      (response: any) => {
        console.log(response);
        this.objectInfoList = response.response
        this.isRepairLoading = false
      },
      (error: any) => {
        console.log(error)
      }
    )
  }



  currency_dropdown_toggle: any = false
  priorityToggle() {
    this.currency_dropdown_toggle = !this.currency_dropdown_toggle
  }

  onCurrencyChange(code: any) {
    const match = this.currencies.find((c: any) => c.code === code);
    console.log(match)
    if (match) this.selectedCurrency = match;
    this.currency_dropdown_toggle = false
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: any) {
    if (event.target.offsetParent.className != "priority-block") {
      this.currency_dropdown_toggle = false;
    }
  }



  loadAllDashboardCharts() {

    // Asset Charts
    this.assetsByTypePieChartDashboard();
    this.assetsAcrossYearsBarChartDashboard();
    this.assetsByTemplateBarChartDashboard();

    this.assetsOriginalCostByBranchPieChartDashboard();
    this.assetsCurrentCostByBranchPieChartDashboard();
    this.assetsCostByTypeBarChartDashboard();

    // Ticket Charts
    this.ticketsByStatusBarChartDashboard();
    this.ticketsByExpectedStartMonthBarChartDashboard();
    this.ticketsByExpectedClosingMonthBarChartDashboard();

    // Inventory Dashboard
    this.getInventoryDashboardData();

    // Operations Dashboard
    this.getOperationsDashboardData();

    // Allocations Dashboard
    this.getAllocationsDashboardData();

    // Logistics Dashboard
    this.getLogisticsDashboardData();
  }





  /* -----------------------------------------
     2. Assets by Type (Pie Chart)
  ------------------------------------------ */
  assetsByTypePieChartDashboard() {
    this.generic_service.assetsByTypePieChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item.Type_a1fa27 === null ? "Unknown" : item.Type_a1fa27
          );

          const values = res.response.map((item: any) => item.count_e2942a);

          this.assetsByTypePieData = {
            labels: labels,
            datasets: [
              {
                // label: "Assets by Type",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     3. Assets Across Years (Bar Chart)
  ------------------------------------------ */
  assetsAcrossYearsBarChartDashboard() {
    this.generic_service.assetsAcrossYearsBarChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item.acquisitionDate_6cf047 === null ? "Unknown" : item.acquisitionDate_6cf047
          );

          const values = res.response.map((item: any) => item.count_e2942a);

          this.assetsAcrossYearsBarData = {
            labels: labels,
            datasets: [
              {
                label: "Assets Across Years",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     4. Assets by Template (Bar Chart)
  ------------------------------------------ */
  assetsByTemplateBarChartDashboard() {
    this.generic_service.assetsByTemplateBarChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item["Design name"] === null ? "Unknown" : item["Design name"]
          );

          const values = res.response.map((item: any) => item["Number of assets"]);

          this.assetsByTemplateBarData = {
            labels: labels,
            datasets: [
              {
                label: "Assets by Template",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     5. Original Cost by Branch (Pie Chart)
  ------------------------------------------ */
  assetsOriginalCostByBranchPieChartDashboard() {
    this.generic_service.assetsOriginalCostByBranchPieChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item.State === null ? "Unknown" : item.State
          );

          const values = res.response.map((item: any) => item["Original cost"]);

          this.assetsOriginalCostByBranchPieData = {
            labels: labels,
            datasets: [
              {
                // label: "Original Cost by Branch",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     6. Current Cost by Branch (Pie Chart)
  ------------------------------------------ */
  assetsCurrentCostByBranchPieChartDashboard() {
    this.generic_service.assetsCurrentCostByBranchPieChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item["State"] === null ? "Unknown" : item["State"]
          );

          const values = res.response.map((item: any) => item["Current cost"]);

          this.assetsCurrentCostByBranchPieData = {
            labels: labels,
            datasets: [
              {
                label: "Current Cost by Branch",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     7. Asset Cost by Type (Bar Chart)
  ------------------------------------------ */
  assetsCostByTypeBarChartDashboard() {
    this.generic_service.assetsCostByTypeBarChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item["Design type"] === null ? "Unknown" : item["Design type"]
          );

          const values = res.response.map((item: any) => item["Original cost"]);

          this.assetsCostByTypeBarData = {
            labels: labels,
            datasets: [
              {
                label: "Asset Cost by Type",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     8. Tickets by Status (Bar Chart)
  ------------------------------------------ */
  ticketsByStatusBarChartDashboard() {
    this.generic_service.ticketsByStatusBarChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item["Latest ticket status"] === null ? "Unknown" : item["Latest ticket status"]
          );

          const values = res.response.map((item: any) => item["Number of tickets"]
          );

          this.ticketsByStatusBarData = {
            labels: labels,
            datasets: [
              {
                label: "Tickets by Status",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     9. Tickets by Expected Start Month
  ------------------------------------------ */
  ticketsByExpectedStartMonthBarChartDashboard() {
    this.generic_service.ticketsByExpectedStartMonthBarChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item["Expected start month"] === null ? "Unknown" : item["Expected start month"]
          );

          const values = res.response.map((item: any) => item["Number of tickets"]);

          this.ticketsByExpectedStartMonthBarData = {
            labels: labels,
            datasets: [
              {
                label: "Tickets by opened date",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }


  /* -----------------------------------------
     10. Tickets by Expected Closing Month
  ------------------------------------------ */
  ticketsByExpectedClosingMonthBarChartDashboard() {
    this.generic_service.ticketsByExpectedClosingMonthBarChartDashboard().subscribe(
      (res: any) => {
        console.log(res);

        if (res.response && res.response.length !== 0) {

          const labels = res.response.map((item: any) =>
            item["Expected closing month"] === null ? "Unknown" : item["Expected closing month"]
          );

          const values = res.response.map((item: any) => item["Number of tickets"]);

          this.ticketsByExpectedClosingMonthBarData = {
            labels: labels,
            datasets: [
              {
                label: "Tickets by closed date",
                data: values,
                backgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ],
                hoverBackgroundColor: [
                  '#4F6D7A', '#FF6F61', '#6B5B95', '#88B04B', '#F7CAC9',
                  '#92A8D1', '#955251', '#B565A7', '#009B77', '#F9B24E',
                  '#EAB8A1', '#D5B021'
                ]
              }
            ]
          };
        }
      },
      (error: any) => console.log(error)
    );
  }

  getInventoryDashboardData() {
    this.generic_service.getInventoryDashboard(this.cid, this.inventoryBranchFilter, this.inventoryDepartmentFilter).subscribe((res: any) => {
      if (!res.error) {
        this.inventoryKpi = res.response.kpiCards || {};
        console.log(this.inventoryKpi, 'this.inventoryKpi');
        console.log(res.response, 'this.inventoryKpi');

        this.inventoryCategoryDistribution = res.response.categoryDistribution || [];
        this.inventoryMakeDistribution = res.response.makeDistribution || [];
        this.inventoryStockPointStats = res.response.stockPointStats || {};
        this.setupInventoryCharts();
      }
    });
  }

  setupInventoryCharts() {
    this.inventoryCategoryChartData = {
      labels: this.inventoryCategoryDistribution.map((item: any) => item.category || 'Uncategorized'),
      datasets: [
        {
          label: 'Asset Count',
          data: this.inventoryCategoryDistribution.map((item: any) => item.count),
          backgroundColor: '#4F6D7A'
        }
      ]
    };

    this.inventoryMakeChartData = {
      labels: this.inventoryMakeDistribution.map((item: any) => {
        let make = item.make || 'Unknown Make';
        let model = item.model ? ` ${item.model}` : '';
        return make + model;
      }),
      datasets: [
        {
          label: 'Asset Count',
          data: this.inventoryMakeDistribution.map((item: any) => item.count),
          backgroundColor: '#FF6F61'
        }
      ]
    };
  }

  getOperationsDashboardData() {
    this.generic_service.getOperationsDashboard(this.cid, this.operationsBranchFilter, this.operationsDepartmentFilter).subscribe((res: any) => {
      if (!res.error) {
        this.operationsConditionMetrics = res.response.conditionMetrics || {};
        this.operationsRepairPipeline = res.response.repairPipeline || {};
        this.operationsMonitoringStats = res.response.monitoringStats || {};
        this.operationsWarrantyAlerts = res.response.warrantyAlerts || {};
        this.setupOperationsCharts();
      }
    });
  }

  setupOperationsCharts() {
    const vendorDist = this.operationsRepairPipeline.vendorDistribution || [];
    this.operationsVendorChartData = {
      labels: vendorDist.map((item: any) => item.vendorName),
      datasets: [
        {
          label: 'Active Repairs',
          data: vendorDist.map((item: any) => item.activeRepairs),
          backgroundColor: '#4F6D7A'
        }
      ]
    };

    this.operationsOnlineChartData = {
      labels: ['Online', 'Offline'],
      datasets: [
        {
          data: [this.operationsMonitoringStats.onlineCount || 0, this.operationsMonitoringStats.offlineCount || 0],
          backgroundColor: ['#88B04B', '#FF6F61']
        }
      ]
    };
  }

  getAllocationsDashboardData() {
    this.generic_service.getAllocationsDashboard(this.cid, this.allocationsBranchFilter, this.allocationsDepartmentFilter).subscribe((res: any) => {
      if (!res.error && res.response) {
        console.log(res.response, 'getAllocationsDashboardData');
        this.allocationStatus = res.response.allocationStatus || {};
        this.departmentUtilization = res.response.departmentUtilization || [];
        this.branchUtilization = res.response.branchUtilization || [];
        this.utilizationRateSummary = res.response.utilizationRateSummary || {};
        this.setupAllocationsCharts();
      }
    });
  }

  setupAllocationsCharts() {
    this.allocationsDepartmentChartData = {
      labels: this.departmentUtilization.map((item: any) => item.department),
      datasets: [
        {
          label: 'Allocated Assets',
          data: this.departmentUtilization.map((item: any) => item.allocatedCount),
          backgroundColor: '#4F6D7A'
        },
        {
          label: 'Total Original Cost',
          data: this.departmentUtilization.map((item: any) => item.totalOriginalCost),
          backgroundColor: '#FF6F61'
        }
      ]
    };

    this.allocationsBranchChartData = {
      labels: this.branchUtilization.map((item: any) => item.branch),
      datasets: [
        {
          label: 'Allocated Assets',
          data: this.branchUtilization.map((item: any) => item.allocatedCount),
          backgroundColor: '#88B04B'
        }
      ]
    };
  }

  getLogisticsDashboardData() {
    this.generic_service.getLogisticsDashboard(this.cid, this.logisticsBranchFilter, this.logisticsDepartmentFilter).subscribe((res: any) => {
      if (!res.error && res.response) {
        this.transitStatusBreakdown = res.response.transitStatusBreakdown || {};
        this.transitValuation = res.response.transitValuation || {};
        this.highTrafficCorridors = res.response.highTrafficCorridors || [];
        this.setupLogisticsCharts();
      }
    });
  }

  setupLogisticsCharts() {
    this.logisticsHighTrafficChartData = {
      labels: this.highTrafficCorridors.map((item: any) => `${item.fromLocation} to ${item.toLocation}`),
      datasets: [
        {
          label: 'Transit Count',
          data: this.highTrafficCorridors.map((item: any) => item.transitCount),
          backgroundColor: '#4F6D7A'
        },
        {
          label: 'Active Count',
          data: this.highTrafficCorridors.map((item: any) => item.activeCount),
          backgroundColor: '#FF6F61'
        }
      ]
    };
  }

  hasChartData(chartData: any): boolean {
    if (!chartData || !chartData.datasets || chartData.datasets.length === 0) {
      return false;
    }
    // Check if at least one dataset has data points and at least one data point is not null/undefined/0 (optional, but length > 0 is usually enough)
    return chartData.datasets.some((dataset: any) => dataset.data && dataset.data.length > 0);
  }

}
